
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/why-choose-us",
      function () {
        return require("private-next-pages/help/why-choose-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/why-choose-us"])
      });
    }
  